import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { TheProblem } from './components/TheProblem';
import { WhyItDidntWork } from './components/WhyItDidntWork';
import { UniqueMethod } from './components/UniqueMethod';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { PriceBlock } from './components/PriceBlock';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream text-navy selection:bg-amber selection:text-navy" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <TheProblem data-id="element-3" />
      <WhyItDidntWork data-id="element-4" />
      <UniqueMethod data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoIsItFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <PriceBlock data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}